import { FieldLabel, Fields } from '@measured/puck';
import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Select } from '../../../page-builder/components/form-fields/Select';
import CustomTooltip from '../../../components/common/tooltip';

// Define the types for FontProps and Fields
type FontType = {
  size: string;
  weight: string;
};

export interface FontProps {
  font: FontType;
}

export const fontSizeOptions = [
  { label: '4', value: 'text-[4px]' },
  { label: '5', value: 'text-[5px]' },
  { label: '6', value: 'text-[6px]' },
  { label: '7', value: 'text-[7px]' },
  { label: '8', value: 'text-[8px]' },
  { label: '9', value: 'text-[9px]' },
  { label: '10', value: 'text-[10px]' },
  { label: '11', value: 'text-[11px]' },
  { label: '12', value: 'text-xs' },
  { label: '13', value: 'text-[13px]' },
  { label: '14', value: 'text-sm' },
  { label: '15', value: 'text-[15px]' },
  { label: '16', value: 'text-base' },
  { label: '17', value: 'text-[17px]' },
  { label: '18', value: 'text-lg' },
  { label: '19', value: 'text-[19px]' },
  { label: '20', value: 'text-xl' },
  { label: '22', value: 'text-[22px]' },
  { label: '23', value: 'text-[23px]' },
  { label: '24', value: 'text-2xl' },
  { label: '32', value: 'text-3xl' },
  { label: '42', value: 'text-[42px]' },
  { label: '54', value: 'text-[54px]' },
  { label: '68', value: 'text-[68px]' },
  { label: '84', value: 'text-[84px]' },
  { label: '98', value: 'text-[98px]' },
];

export const fontWeightOptions = [
  { label: 'Normal', value: 'font-normal' },
  { label: 'Bold', value: 'font-bold' },
  { label: 'Bolder', value: 'font-extrabold' },
  { label: 'Light', value: 'font-light' },
  { label: 'Semi Bold', value: 'font-semibold' },
  { label: 'Extra Light', value: 'font-extralight' },
  { label: 'Lighter', value: 'font-lighter' },
];

// Font field definition
export const fontField: Fields<FontProps> = {
  font: {
    type: 'custom',
    label: 'Font',
    render: ({ value, onChange }) => {
      const [isOpen, setIsOpen] = useState(false);

      const toggleAccordion = () => {
        setIsOpen(!isOpen);
      };

      const handleChange = (
        key: string,
        option: React.ChangeEvent<HTMLSelectElement>,
      ) => {
        onChange({
          ...value,
          [key]: option.target.value,
        });
      };

      return (
        <div>
          <div
            className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
            onClick={toggleAccordion}>
            <h3>Customize Fonts</h3>
            {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
          </div>
          {isOpen && (
            <div className="flex flex-col gap-4 mt-3 items-center border border-gray-300 rounded p-2 w-full pagebuilder-theme">
              <div className="border border-gray-300 rounded p-2 w-full pagebuilder-theme">
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="fontSize">
                        <span>Size</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Select
                    className="pagebuilder-theme"
                    value={value?.size}
                    onChange={e => handleChange('size', e)}
                    options={fontSizeOptions}
                    label=""
                  />
                </FieldLabel>
              </div>
              <div className="border border-gray-300 rounded p-2 w-full pagebuilder-theme">
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="fontWeight">
                        <span>Weight</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Select
                    value={value?.weight}
                    onChange={e => handleChange('weight', e)}
                    options={fontWeightOptions}
                    label=""
                  />
                </FieldLabel>
              </div>
            </div>
          )}
        </div>
      );
    },
  },
};
